import enTranslation from './English/translation'
import idTranslation from './Indonesia/translation'
 
export default {
    en: {
      translation: enTranslation
    },
    id: {
      translation: idTranslation
    }
  };


// WEBPACK FOOTER //
// ./src/locales/resources.js